import { Component, Inject, Input, LOCALE_ID, OnInit, ViewEncapsulation } from '@angular/core';
import { ProductDescriptionSection } from '@scalefast/core';
import { AppAccordionComponent } from '../../../shared/components/accordion/accordion.component';

@Component({
  selector: 'app-product-policy-accordion',
  styleUrls: ['./product-policy-accordion.component.scss'],
  template: '<app-accordion class="product-policy__accordion" [sections]="sections" [oppenedDefault]="oppenedDefault" />',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AppAccordionComponent],
})
export class AppProductPolicyAccordionComponent implements OnInit {
  sections: Array<ProductDescriptionSection> = [{ title: '', content: '' }];

  @Input() oppenedDefault: boolean = true;

  constructor(@Inject(LOCALE_ID) private locale: string) {}

  ngOnInit(): void {
    this.setSections();
  }

  setSections() {
    switch (this.locale) {
      case 'es-ES':
        this.sections = [
          {
            title: 'Política de devolución y prueba gratis 30 días',
            content: `<p>Es importante que compruebe su pedido o sus artículos cuando los reciba y siempre antes de utilizarlos. En caso de que haya algún error o surja algún problema,
            debe comunicárnoslo inmediatamente para que podamos investigarlo. Póngase en contacto con nuestro equipo de atención al cliente.</p>
            <p>DERECHO DE DESISTIMIENTO</p>
            <p>Tiene usted derecho a desistir de este contrato en un plazo de 30 días sin necesidad de justificación.</p>
            <p>Para ejercer su derecho de desistimiento deberá informarnos de su decisión de desistir del presente contrato, asimismo, deberá devolvernos sin demora los productos.</p>
            <p>Le devolveremos todos los pagos que hayamos recibido de usted, incluidos los gastos de envío. Deberá asumir los gastos directos de devolución de los productos, salvo que
            la devolución se solicite debido a un error por nuestra parte (artículo equivocado, dañado o defectuoso, o devoluciones de artículos de sustitución que no desee conservar).</p>
            <p>Efectuaremos el reembolso sin demora indebida y a más tardar:</p>
            <ul><li>30 días después del día en que recibamos su devolución; o bien</li>
            <li>(Si es antes) 30 días después del día en que aporte justificación de haber devuelto los artículos; o bien</li>
            <li>En caso de que no se hayan suministrado artículos, 30 días después del día en que nos haya comunicado su decisión de dejar sin efecto el contrato.</li></ul>
            <p>¿QUÉ DEBO HACER SI RECIBO UN ARTÍCULO INCORRECTO, EL ARTÍCULO ESTÁ DAÑADO O TIENE UN DEFECTO?</p>
            <p>Le rogamos que se ponga en contacto con nosotros a través de su cuenta utilizando el centro de mensajes online o enviando un correo a
            <a href=\mailto:oralbshopes_support@esw.com\>oralbshopes_support@esw.com</a>. Por favor, adjunte al mensaje cualquier fotografía que tenga que muestre el producto
            recibido y/o demuestre los daños/defectos.</p>
            <p>¿CÓMO PUEDO ORGANIZAR UNA DEVOLUCIÓN?</p>
            <p>Póngase en contacto con nuestro servicio de atención al cliente para organizar la devolución.</p>
            <p>Deberá facilitarnos el número de pedido, el artículo que desea devolver y el motivo de la devolución (si se realiza en un plazo superior a 30 días).
            Una vez recibidos estos datos, le facilitaremos toda la información necesaria para organizar la devolución.</p>
            <p>Empaquete el artículo de forma segura y asegúrese de incluir nuestro formulario de devolución en el interior.</p>
            <p>No olvide solicitar un justificante del envío cuando nos envíe el artículo.</p>
            <p>Cualquier artículo que usted haya aceptado y luego devuelto es su responsabilidad hasta que llegue a nuestro almacén.</p>
            <p>PROGRAMA DE GARANTÍA DE DEVOLUCIÓN DE DINERO DE 30 DÍAS (válido para cepillos eléctricos e irrigadores dentales)</p>
            <p>En el caso de los cepillos eléctricos y los irrigadores dentales, le damos la oportunidad de probarlos. Si no está totalmente satisfecho, puede devolver el artículo
            en un plazo de 30 días a partir de la fecha de compra. Para ello haga <a target="_blank" href="https://www.oralb.es/es-es/30-dias-de-prueba-gratis">clic aquí</a>.</p>
            <p>Puede acceder a nuestra Política de devoluciones y derecho de desistimiento completa aquí:
            <a target="_blank" href="https://www.oralb.es/es-es/docs/rp">Política de devolución y derecho de desistimiento | Oral-B (oralb.es)</a>.</p>`,
          },
        ];
        break;
      case 'fr-FR':
        this.sections = [
          {
            title: 'Livraison & retours',
            content: `<p>Livraison estimée en 5 jours ouvrés | 8.99€ et <strong>gratuite dès 69.99€ d'achat.</strong></p>
            <p>Si vous ne pouvez pas réceptionner votre colis chez vous, vous pouvez <b>choisir un Point Relais</b> (à renseigner dans le mail de suivi de DHL, notre transporteur).</p>
            <p><b>Vous disposez d'un délai de 14jours à compter de la réception du colis pour retourner vos produits.</b></p>
            <p>Les articles que vous souhaitez retourner doivent être conditionnés dans leur emballage d'origine. Le retour est à votre charge.</p>`,
          },
        ];
        break;
    }
  }
}
